// is NODE_ENV set to "development"
const isNodeModeDevelopment = import.meta.env.DEV
// is NODE_ENV set to "production"
const isNodeModeProduction = import.meta.env.PROD

// run vite command: "vite" -> mode: development
const viteModeValueDevelopment = 'development'
// run vite command: "vite build" -> mode: production
const viteModeValueProduction = 'production'
// run vite command "vite build --mode cus" | "vite --mode cus" -> mode: cus
// const viteModeValueCustom = 'cus'

const checkViteMode = (environmentValue: string): boolean => {
  const currentViteMode = import.meta.env.MODE

  return currentViteMode === environmentValue
}

const isViteModeDevelopment = checkViteMode(viteModeValueDevelopment)
const isViteModeProduction = checkViteMode(viteModeValueProduction)
// const isViteModeCustom = checkViteMode(viteModeValueCustom)

const isEnvironmentDevelopment = isNodeModeDevelopment || isViteModeDevelopment
const isEnvironmentProduction = isNodeModeProduction && isViteModeProduction
// const isEnvironmentCustom = isViteModeCustom

// this is different from NODE_ENV (see Vite NODE_ENV and Modes in the documentation)
const viteMode = import.meta.env.MODE

// get vite (e.g. vite development server) base url, change with "base" configuration option for other environments
const viteBaseUrl = import.meta.env.BASE_URL

// custom enviroments:
const viteModeValueStaging = 'staging'
const isViteModeStaging = checkViteMode(viteModeValueStaging)
const isEnvironmentStaging = (isNodeModeDevelopment || isNodeModeProduction) && isViteModeStaging

export {
  isEnvironmentDevelopment,
  isEnvironmentProduction,
  isEnvironmentStaging,
  isNodeModeDevelopment,
  isNodeModeProduction,
  isViteModeDevelopment,
  isViteModeProduction,
  viteBaseUrl,
  viteMode,
}
